// app/javascript/controllers/search_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  connect() {
    this.timeout = null
    this.urlValue = "/search"
  }

  search() {
    clearTimeout(this.timeout)
    
    const query = this.inputTarget.value.trim()
    
    if (query.length < 2) {
      this.hideResults()
      return
    }

    // Debounce the search to avoid too many requests
    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  async performSearch(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      
      if (response.ok) {
        const results = await response.json()
        this.displayResults(results)
      }
    } catch (error) {
      console.error('Search error:', error)
    }
  }

  displayResults(results) {
    if (results.length === 0) {
      this.resultsTarget.innerHTML = '<div class="search-result-item no-results">No results found</div>'
    } else {
      this.resultsTarget.innerHTML = results.map(result => {
        const resultClass = result.type === 'product' ? 'product-result' : 'menu-result'
        
        return `<a href="${result.url}" class="search-result-item ${resultClass}">
          <div class="result-name">${this.highlightQuery(result.name)}</div>
        </a>`
      }).join('')
    }
    
    this.showResults()
  }

  highlightQuery(text) {
    const query = this.inputTarget.value.trim()
    if (!query) return text
    
    const regex = new RegExp(`(${query})`, 'gi')
    return text.replace(regex, '<strong>$1</strong>')
  }

  showResults() {
    this.resultsTarget.style.display = 'block'
  }

  hideResults() {
    this.resultsTarget.style.display = 'none'
  }

  // Hide results when clicking outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  // Handle keyboard navigation
  keydown(event) {
    const items = this.resultsTarget.querySelectorAll('.search-result-item:not(.no-results)')
    const currentActive = this.resultsTarget.querySelector('.search-result-item.active')
    
    switch(event.key) {
      case 'ArrowDown':
        event.preventDefault()
        if (currentActive) {
          currentActive.classList.remove('active')
          const next = currentActive.nextElementSibling
          if (next) {
            next.classList.add('active')
          } else {
            items[0]?.classList.add('active')
          }
        } else {
          items[0]?.classList.add('active')
        }
        break
        
      case 'ArrowUp':
        event.preventDefault()
        if (currentActive) {
          currentActive.classList.remove('active')
          const prev = currentActive.previousElementSibling
          if (prev) {
            prev.classList.add('active')
          } else {
            items[items.length - 1]?.classList.add('active')
          }
        } else {
          items[items.length - 1]?.classList.add('active')
        }
        break
        
      case 'Enter':
        event.preventDefault()
        if (currentActive && !currentActive.classList.contains('no-results')) {
          window.location.href = currentActive.href
        }
        break
        
      case 'Escape':
        this.hideResults()
        this.inputTarget.blur()
        break
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener('click', this.clickOutside.bind(this))
  }
}